// export const API_BASE_URL =
//     process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://salty-lowlands-52211.herokuapp.com';



// WEBPACK FOOTER //
// ./src/config.js